var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6177 10.7608C10.2569 10.983 10 11.3578 10 11.7816C10 12.0075 9.85818 12.2112 9.64083 12.2729C9.11933 12.4208 8.56891 12.5 8 12.5C7.43109 12.5 6.88067 12.4208 6.35917 12.2729C6.14182 12.2112 6 12.0075 6 11.7816C6 11.3578 5.74314 10.983 5.38228 10.7608C3.95293 9.8808 3 8.30168 3 6.5C3 3.73858 5.23858 1.5 8 1.5C10.7614 1.5 13 3.73858 13 6.5C13 8.30168 12.0471 9.8808 10.6177 10.7608Z",
    fill: "#00B1B2",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86696 13.9151C6.45741 13.8531 6.07514 14.1348 6.01313 14.5444C5.95112 14.9539 6.23286 15.3362 6.64241 15.3982C7.08559 15.4653 7.53898 15.5 8 15.5C8.46102 15.5 8.91442 15.4653 9.3576 15.3982C9.76715 15.3362 10.0489 14.9539 9.98688 14.5444C9.92487 14.1348 9.5426 13.8531 9.13305 13.9151C8.76394 13.971 8.3856 14 8 14C7.6144 14 7.23607 13.971 6.86696 13.9151Z",
    fill: "#00B1B2",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.7347c9322e750d8704dc7d433ffe535f.svg";
export { ForwardRef as ReactComponent };